import React, { useState } from 'react';
import { useContext } from 'react';
import Swal from 'sweetalert2';
import AuthContext from '../../store/auth-context';
import FormBtn from '../Form/FormBtn';
import TextField from '../Form/TextField';

const AdminUserContent = () => {
  const context = useContext(AuthContext);
  const [firstname, setFirstname] = useState(context.userDetails.firstName);
  const [lastname, setLastname] = useState(context.userDetails.lastName);
  const [email, setEmail] = useState(context.userDetails.email);

  const firstNameChangeHandler = (event) => {
    setFirstname(event);
  };
  const lastNameChangeHandler = (event) => {
    setLastname(event);
  };
  const emailChangeHandler = (event) => {
    setEmail(event);
  };

  const onFormSubmit = (event) => {
    event.preventDefault();

    const data = {
      firstName: firstname,
      lastName: lastname,
      email: email,
    };

    fetch('https://aifolio-api.herokuapp.com/api/user/update', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          context.userDataHandler(data);

          Swal.fire({
            icon: 'success',
            title: 'Successfully edited user data',
            timer: 1000,
          });
        }
      })
      .catch((err) => console.log(err));

    context.userDataHandler(data);
  };

  return (
    <form onSubmit={onFormSubmit}>
      <TextField
        label='firstname'
        inputHandler={firstNameChangeHandler}
        value={firstname}
        type='text'
      />
      <TextField
        label='lastname'
        inputHandler={lastNameChangeHandler}
        value={lastname}
        type='text'
      />
      <TextField
        label='email'
        inputHandler={emailChangeHandler}
        value={email}
        type='email'
      />
      <FormBtn label='Login' type='submit' />
    </form>
  );
};

export default AdminUserContent;
